import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@evaneos/b2b-ui';
import { useIntl } from 'react-intl';

import { useGetTrackedTripProperties, useTrackEventAmplitude } from '../../../../shared/analytics';
import { DossierId } from '../../../../resources/dossier/types';

type ConfirmRegenerationModalProps = {
    open: boolean;
    setOpen: (open: boolean) => void;
    type: 'transcript' | 'summary';
    handleConfirmation: () => void;
    dossierId: DossierId;
};

export const ConfirmRegenerationModal = ({
    open,
    setOpen,
    type,
    handleConfirmation,
    dossierId,
}: ConfirmRegenerationModalProps) => {
    const { formatMessage } = useIntl();

    const { trackEvent } = useTrackEventAmplitude();
    const trackedTripProperties = useGetTrackedTripProperties(dossierId);

    const handleConfirmationClick = () => {
        trackEvent((ampli, defaultProperties) => {
            ampli.regenerateRecordingAiContentClicked({
                ...defaultProperties,
                ...trackedTripProperties,
                source_regeneration:
                    type === 'transcript' ? 'recording raw transcript' : 'recording summary',
            });
        });
        setOpen(false);
        handleConfirmation();
    };

    const titleId =
        type === 'transcript'
            ? 'experiment.better_business.dossier.discussion.phone_call.regeneration.transcript.modal.title'
            : 'experiment.better_business.dossier.discussion.phone_call.regeneration.summary.modal.title';

    const descriptionId =
        type === 'transcript'
            ? 'experiment.better_business.dossier.discussion.phone_call.regeneration.transcript.modal.description'
            : 'experiment.better_business.dossier.discussion.phone_call.regeneration.summary.modal.description';

    const confirmButtonId =
        type === 'transcript'
            ? 'experiment.better_business.dossier.discussion.phone_call.regeneration.transcript.modal.confirm_button'
            : 'experiment.better_business.dossier.discussion.phone_call.regeneration.summary.modal.confirm_button';

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title" variant="h2">
                {formatMessage({ id: titleId })}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description" variant="body1">
                    {formatMessage({ id: descriptionId })}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="text" color="secondary" onClick={() => setOpen(false)}>
                    {formatMessage({
                        id: 'form.cancel',
                    })}
                </Button>
                <Button
                    color="primary"
                    disableElevation={true}
                    autoFocus
                    onClick={handleConfirmationClick}
                >
                    {formatMessage({ id: confirmButtonId })}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
